import { Route, Routes } from 'react-router-dom';

import { HeaderGeneral } from '@/components/DybrComponents/HeaderGeneral';
import { NavTab } from '@/components/DybrComponents/NavTab';
import { ServiceBackground } from '@/components/DybrComponents/ServiceBackground';
import TabsContainer from '@/components/DybrComponents/TabsContainer';
import BlogList from '@/scenes/Dybr/Feeds/BlogList';
import { CommonFeed } from '@/scenes/Dybr/Feeds/CommonFeed';

function FeedScenes() {
  return (
    <ServiceBackground data-testid="feed-scenes">
      <HeaderGeneral paddingBottom="45px">
        <h1>дыбр</h1>
        <TabsContainer>
          <NavTab to="blogs">все дневники</NavTab>
          <NavTab to="communities">все сообщества</NavTab>
          <NavTab to="." end>
            общая лента
          </NavTab>
        </TabsContainer>
      </HeaderGeneral>

      <Routes>
        <Route path="/" element={<CommonFeed />} />
        <Route path="/communities" element={<BlogList isCommunity={true} />} />
        <Route path="/blogs" element={<BlogList isCommunity={false} />} />
      </Routes>
    </ServiceBackground>
  );
}

export default FeedScenes;
